import ResourceCard, { Bold, Title } from "./ResourceCard";
import { useQuickStartContext } from "./QuickStartCard";


export default function AiResultsSDEResources() {
  const { programmingLanguage } = useQuickStartContext();

  return (
    <>
      <ResourceCard
        title={ <Title>See all available <Bold>Structured Data Endpoints</Bold></Title> }
        linkHref={ `https://docs.scraperapi.com/${programmingLanguage}/making-requests/structured-data-collection-method` }
        tracked
        trackedTitle="Structured Data Collection Method"
      />

      <ResourceCard
        title={ <Title>Try it out in the <Bold>API Playground</Bold></Title> }
        linkHref="/apiplayground"
        tracked
        trackedTitle="API Playground"
      />

      <ResourceCard
        title={ <Title>Let us <Bold>host your AI Results requests</Bold></Title> }
        linkHref="https://docs.scraperapi.com/datapipeline/how-to-create-a-new-datapipeline-project/input-and-parameters#input-for-use-case-specific-project-types"
        tracked
        trackedTitle="Input for use case specific project types"
      />
    </>
  );
};
